/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-11-09 14:25:00
 */

 import {default as CellOperate} from "../../../../components/agGridComponent/cellOperate";
 import {ColDefCustom, default as AgGridVueCustomTsx} from "../../../../components/agGridCustom/agGridVueCustomTsx";
 import _ from 'lodash'
 import ListPageService from "../../../../types/ListPage";
 import override from "../../../../dectorators/override";
 import {DateTimeUtil} from "../../../../util/dateTimeUtil";
 import {QueryFormVOI} from "../../../../components/queryForm/queryForm";
 import OperatingKeyApi,{OperatingKeyDOI} from '../api/operatingKey';
 import OperatingKey from '../operatingKey';
 import AreaCascader from 'src/components/areaCascader/areaCascader';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import Input from 'src/types/iview/Input';
 import EnumStationType from 'src/enums/enumStationType';
 import { Toast } from 'src/util/toast';
 import DatePicker from 'src/types/iview/DatePicker';
 
 export default class OperatingKeyService extends ListPageService {
     ctx: OperatingKey;

     constructor (ctx: OperatingKey) {
        super()
        this.ctx = ctx
     }
 
     @override
     createColumns (): ColDefCustom [] {
         let t = this
         return [
             {
                 headerName: '时间',
                 field: 'datetime',
                 minWidth: 190,
             },
             {
                 headerName: '操作人',
                 field: 'operator',
                 minWidth: 120
             },
             {
                 headerName: '报错号',
                 field: 'error_no',
                 minWidth: 160,
             },
             {
                headerName: '报错信息',
                field: 'error_info',
                minWidth: 160,
             },
             {
                 headerName: '内容',
                 field: 'content',
                 minWidth: 300,
             },
         ]
     }
 
     @override
     creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: Input,
                label: '报错信息',
                labelWidth: 100,
                width: 240,
                field: 'error_info',
                props: { value: "", placeholder: '报错信息' },
            },
            {
				component: DatePicker,
				label: '时间',
                field: 'time',
                width: 300,
                realField: ['start_time','end_time'],
                timeType: 'number',
                props: {value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间'},
            }
        ];
     }
 
     @override
     initSearchParams (): void {
         this.ctx.searchParams = {
             ...this.ctx.queryForm.getQueryObj<OperatingKeyDOI.QueryRowDataParamsI>(),
             page_index: this.ctx.currentPage,
             page_size: this.ctx.pageSize,
         }
         this.ctx.currentPage = 1
     }
 
     @override
     async searchTable () {
         let ctx = this.ctx
         let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
         ag.showLoading()
         let {code, data} = await OperatingKeyApi.searchList({
             ...ctx.searchParams,
             page_size: ctx.pageSize,
             page_index: ctx.currentPage
         })
         ag.hideLoading()
         if (code === 0) {
             ctx.rowData = data.data_info || [];
             ctx.total = data.page_count
         }
     }
 
 }